import {
  EMPTY_AGENT_RESOURCE_ELMA365_APP_SETTINGS,
  EMPTY_AGENT_RESOURCE_ELMA365_FILE_SETTINGS,
  EMPTY_AGENT_RESOURCE_ELMA365_SESSION_SETTINGS,
} from './const';
import {
  AgentResourceELMA365AppSettingsType,
  AgentResourceELMA365FileSettingsType,
  AgentResourceELMA365SessionSettingsType,
} from './types';

const tryExtractUuid = (text: string): string | null => {
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
  const match = text.match(uuidRegex);
  return match ? match[0] : null;
};

const tryGetLastUuidFromPathName = (pathname: string): string | null | undefined => {
  const pathItems = pathname.split('/');
  const uuids = pathItems.map(tryExtractUuid).filter((uuid) => !!uuid);
  return uuids.length ? uuids.pop() : null;
};

export const buildELMA365AppSettings = (viewUrl: string): AgentResourceELMA365AppSettingsType => {
  let baseUrl = '';
  let namespace = '';
  let code = '';
  let id = '';

  try {
    const ulrObject = new URL(viewUrl);
    baseUrl = ulrObject.origin;

    const pathItems = ulrObject.pathname.split('/');
    const startIndex = pathItems.findIndex((item) => item.endsWith('(p:item'));
    namespace = pathItems[startIndex + 1];
    code = pathItems[startIndex + 2];
    id = tryGetLastUuidFromPathName(ulrObject.pathname) || '';
  } catch (err) {
    // NOTE: skip error
  }

  return {
    ...EMPTY_AGENT_RESOURCE_ELMA365_APP_SETTINGS,
    view_url: viewUrl,
    base_url: baseUrl,
    namespace,
    code,
    id,
  };
};

export const buildELMA365SessionSettings = (viewUrl: string): AgentResourceELMA365SessionSettingsType => {
  let baseUrl = '';
  let sessionId = '';

  try {
    const ulrObject = new URL(viewUrl);
    baseUrl = ulrObject.origin;
    sessionId = tryGetLastUuidFromPathName(ulrObject.pathname) || '';
  } catch (err) {
    // NOTE: skip error
  }

  return {
    ...EMPTY_AGENT_RESOURCE_ELMA365_SESSION_SETTINGS,
    view_url: viewUrl,
    base_url: baseUrl,
    session_id: sessionId,
  };
};

export const buildELMA365FileSettings = (viewUrl: string): AgentResourceELMA365FileSettingsType => {
  let baseUrl = '';
  let fileId = '';

  try {
    const ulrObject = new URL(viewUrl);
    baseUrl = ulrObject.origin;
    fileId = tryGetLastUuidFromPathName(ulrObject.pathname) || '';
  } catch (err) {
    // NOTE: skip error
  }

  return {
    ...EMPTY_AGENT_RESOURCE_ELMA365_FILE_SETTINGS,
    view_url: viewUrl,
    base_url: baseUrl,
    file_id: fileId,
  };
};
